'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { ChevronDown } from '@/components/icons/ChevronDown';
import { FeatureCard } from '@/components/page-builder/global/featureRoadmap/FeatureCard';
import { getGridColumnClass, getGridRowClass } from '@/components/page-builder/global/featureRoadmap/grid-helper';
import { useCollapsibleCategories } from '@/components/page-builder/global/featureRoadmap/useCollapsibleCategories';
import Heading from '@/components/typography/Heading';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { cn } from '@/lib/styles';
type FeatureRoadmapDesktopProps = {
  readonly categories: Data.Component<'shared.roadmap-category'>[];
  readonly primaryColumnTitle: string;
  readonly secondaryColumnTitle: string;
};
export function FeatureRoadmapDesktop(t0) {
  const $ = _c(19);
  const {
    categories,
    primaryColumnTitle,
    secondaryColumnTitle
  } = t0;
  const {
    openCategories,
    toggleCategory
  } = useCollapsibleCategories(categories);
  let t1;
  if ($[0] !== primaryColumnTitle) {
    t1 = <div className="w-fit lok-text-display-small text-brand-black">{primaryColumnTitle}</div>;
    $[0] = primaryColumnTitle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== secondaryColumnTitle) {
    t2 = <div className="w-fit lok-text-display-small text-brand-black">{secondaryColumnTitle}</div>;
    $[2] = secondaryColumnTitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="grid grid-cols-2 gap-14 mb-12 px-0">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== categories || $[8] !== openCategories || $[9] !== toggleCategory) {
    let t5;
    if ($[11] !== openCategories || $[12] !== toggleCategory) {
      t5 = category => {
        if (!category || !category.id) {
          return null;
        }
        const categoryId = category.id;
        const isOpen = openCategories[categoryId] ?? false;
        const hasItems = category.primaryColumnItems && category.primaryColumnItems.length > 0 || category.secondaryColumnItems && category.secondaryColumnItems.length > 0;
        if (!hasItems) {
          return null;
        }
        return <Collapsible key={categoryId} open={isOpen} onOpenChange={() => toggleCategory(categoryId)} className="w-full"><CollapsibleTrigger className="group inline-flex items-center gap-2 cursor-pointer py-5 hover:opacity-70 transition-opacity"><Heading tag="h2" fontSize="headingSmall">{category.title}</Heading><ChevronDown className={cn("size-5 transition-transform duration-200", isOpen && "rotate-180")} /></CollapsibleTrigger><CollapsibleContent><div className="grid grid-cols-[1fr_1fr_calc(var(--spacing)*3.5)_1fr_1fr] gap-5">{category.primaryColumnItems?.map(_temp)}{category.secondaryColumnItems?.map(_temp2)}</div></CollapsibleContent></Collapsible>;
      };
      $[11] = openCategories;
      $[12] = toggleCategory;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    t4 = categories.map(t5);
    $[7] = categories;
    $[8] = openCategories;
    $[9] = toggleCategory;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <div className="flex flex-col gap-12">{t4}</div>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t5) {
    t6 = <div className="hidden lg:block bg-white rounded-xl">{t3}{t5}</div>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}
function _temp2(item_0, index_0) {
  return item_0 ? <div key={item_0.id} className={cn(getGridColumnClass(index_0, "secondary"), getGridRowClass(index_0))}><FeatureCard item={item_0} variant="secondary" /></div> : null;
}
function _temp(item, index) {
  return item ? <div key={item.id} className={cn(getGridColumnClass(index, "primary"), getGridRowClass(index))}><FeatureCard item={item} /></div> : null;
}